import { Event } from '~/Features/Messaging/types';
import type { OnlineApplicationChoice } from '~/Features/OnlineApplication/Model';

export class BasketEvent extends Event {
    constructor(
        public choices: OnlineApplicationChoice[],
        id: string
    ) {
        super(id);
    }
}

export class AddedToBasket extends BasketEvent {
    public static readonly id = 'AddedToBasket';

    constructor(choices: OnlineApplicationChoice | OnlineApplicationChoice[]) {
        const choicesArray = ([] as OnlineApplicationChoice[]).concat(choices);
        super(choicesArray, AddedToBasket.id);
    }
}

export class RemovedFromBasket extends BasketEvent {
    public static readonly id = 'RemovedFromBasket';

    constructor(choices: OnlineApplicationChoice | OnlineApplicationChoice[]) {
        const choicesArray = ([] as OnlineApplicationChoice[]).concat(choices);
        super(choicesArray, RemovedFromBasket.id);
    }
}
